import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  MiniEssay,
  Body,
  Data,
  Theme,
} from '../coreui';

import VisibilityTrigger from '../components/VisibilityTrigger';
import DynamicBrowseJoinLink from '../helpers';
import FadeIn from '../components/FadeIn';

const paragraphsOfText = [
  'The way an investor owns real estate can be just as important as the underlying real estate and investment strategy. Considerations need to be made for taxes, transparency, property operations, potential tenant issues, diversification and individual financial responsibility.',
];

const PassiveVsActive = ({ isLoggedIn }) => {
  return (
    <ExtendedFlex
      flexDirection="column"
      align="center"
      mx="auto"
      my={[50, 50, 100]}
      maxWidth={1500}
    >
      <VisibilityTrigger
        trigger="isVisible"
      >
        <MiniEssay
          header={'PASSIVE VS. ACTIVE FORMS OF OWNERSHIP'}
          paragraphsOfText={paragraphsOfText}
        />
      </VisibilityTrigger>
      <ExtendedFlex
        flexDirection={['column', 'column', 'row', 'row', 'row']}
        mt={[10, 20, 40, 50, 50]}
      >
        <FadeIn>
          <ExtendedFlex
            flexDirection="column"
            justify="space-around"
            maxWidth={680}
            w={1}
            mb={0}
            align="center"
            transition={`opacity ${Theme.fadeInDelay}ms 0s linear`}
          >
            <Data
              type="D5"
              color="#9b9b9b"
            >
              Not offered by RealtyMogul
            </Data>
            <ExtendedFlex
              w="97%"
              bg="#202020"
              align="center"
            >
              <Data
                type="D4"
                mx="auto"
                color="#FFFFFF"
                textAlign="center"
                my={3}
              >
                HIGHER MINIMUM INVESTMENT & INVOLVEMENT
              </Data>
            </ExtendedFlex>
            <ExtendedFlex
              flexDirection={['row', 'row', 'row', 'row', 'row']}
              justify="space-around"
              width={[1, 1, 1, 1, 1]}
              mb={0}
            >
              <ExtendedFlex
                bg="gray.0"
                m={10}
                height={[105, 75, 125, 100, 135]}
                maxWidth={340}
              >
                <Body
                  type="B3"
                  textAlign="center"
                  m={0}
                  px="5%"
                  py="5%"
                >
                  Investor purchases their own income
                  property & hires a third party property
                  manager to oversee the property.
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                bg="gray.0"
                m={10}
                height={[105, 75, 125, 100, 135]}
                maxWidth={340}
              >
                <Body
                  type="B3"
                  textAlign="center"
                  m={0}
                  px="5%"
                  py="5%"
                >
                  Investor purchases their own income
                  property & does their own property
                  management & upkeep.
                </Body>
              </ExtendedFlex>
            </ExtendedFlex>
          </ExtendedFlex>
        </FadeIn>
        <FadeIn>
          <ExtendedFlex
            flexDirection="column"
            justify="space-around"
            maxWidth={680}
            w={1}
            mb={0}
            align="center"
            transition={`opacity ${Theme.fadeInDelay}ms 0.3s linear`}
          >
            <Data type="D5">
              Offered by RealtyMogul
            </Data>
            <ExtendedFlex
              w="97%"
              bg="#176DB6"
            >
              <Data
                type="D4"
                mx="auto"
                color="#FFFFFF"
                textAlign="center"
                my={3}
              >
                LOWER MINIMUM INVESTMENT & INVOLVEMENT
              </Data>
            </ExtendedFlex>
            <ExtendedFlex
              flexDirection={['row', 'row', 'row', 'row', 'row']}
              justify="space-around"
              width={[1, 1, 1, 1, 1]}
              mb={0}
            >
              <ExtendedFlex
                bg="gray.0"
                height={[105, 75, 125, 100, 135]}
                maxWidth={340}
                m={10}
              >
                <Body
                  type="B3"
                  textAlign="center"
                  m={0}
                  px="5%"
                  py="5%"
                >
                  Investment in a fund that invests in
                  properties managed by operating partners
                  who handle the day to day.
                </Body>
              </ExtendedFlex>
              <ExtendedFlex
                bg="gray.0"
                height={[105, 75, 125, 100, 135]}
                maxWidth={340}
                m={10}
              >
                <Body
                  type="B3"
                  textAlign="center"
                  m={0}
                  px="5%"
                  py="5%"
                >
                  Investment in a property with an
                  operating partner who handles the
                  day-to-day & provides oversight
                  & management.
                </Body>
              </ExtendedFlex>
            </ExtendedFlex>
          </ExtendedFlex>
        </FadeIn>
      </ExtendedFlex>
      <ExtendedFlex
        pt={60}
        flexDirection="column"
        align="center"
      >
        <DynamicBrowseJoinLink
          type="L1"
          isLoggedIn={isLoggedIn}
        />
      </ExtendedFlex>
    </ExtendedFlex>
  );
};


PassiveVsActive.propTypes = {
  isLoggedIn: PropTypes.bool,
};

export default PassiveVsActive;
